
import { ArrowRight, Globe } from "lucide-react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-gray-50 border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex flex-col items-center justify-center space-y-4">
          <div className="flex items-center space-x-4 mb-2">
            <Globe className="h-4 w-4 text-gray-500" aria-hidden="true" />
            <nav className="flex space-x-3">
              <Link to="/" className="text-sm text-gray-600 hover:text-gray-900">English</Link>
              <Link to="/es" className="text-sm text-gray-600 hover:text-gray-900">Español</Link>
              <Link to="/zh" className="text-sm text-gray-600 hover:text-gray-900">中文</Link>
            </nav>
          </div>
          <p className="text-sm text-gray-500 text-center">
            DeepSeek.ai is not affiliated with, endorsed by, or connected to DeepSeek.com in any way.
          </p>
          <a
            href="https://www.deepseek.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-[#0b57d0] hover:text-[#0b57d0]/80 transition-colors flex items-center"
            aria-label="Visit DeepSeek.com in a new tab"
          >
            Looking for DeepSeek.com?
            <ArrowRight className="ml-1 h-4 w-4 inline" aria-hidden="true" />
          </a>
          <p className="text-sm text-gray-500">
            © {new Date().getFullYear()} DeepSeek AI. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
